import { useEffect } from 'react';
import { useRedirect } from 'src/core';
import { useStore } from 'src/context';

/**
 * <Summary /> props
 */
const useSummaryProps = ({
  setSurveyIsCompleted
}: {
  setSurveyIsCompleted: (value: boolean) => void;
}) => {
  useRedirect();

  const { autocloseMessage } = useStore();

  useEffect(
    () => () => {
      setSurveyIsCompleted?.(true);
    },
    []
  );

  return {
    autocloseMessage
  };
};

export { useSummaryProps };
